import React from 'react';
import { Spinner } from '../../components/ui';
import { fmtDateTime } from '../../utils/helpers';
import { userName, statusClass, statusText, deviceText } from './useUserManagement';
import UserEditForm from './UserEditForm';

// Desktop User Management — compact table, row click = edit.
export default function UserManagementDesktop({ vm }) {
  const { isSuperAdmin, isSelf, filtered, loading, q, setQ, open, openAdd, openEdit, softDelete, toggleActive, resetDevice } = vm;

  if (!isSuperAdmin) {
    return (
      <div>
        <div className="page-head"><h1>User Management</h1></div>
        <div className="card card-pad empty">Only Super Admin can manage all users.</div>
      </div>
    );
  }

  return (
    <div>
      <div className="page-head">
        <h1>User Management</h1>
        <span className="muted">{filtered.length}</span>
        <div className="spacer" />
        <input placeholder="Search users..." value={q} onChange={(e) => setQ(e.target.value)}
          style={{ padding: '9px 12px', border: '1px solid var(--line)', borderRadius: 10, maxWidth: 220 }} />
        <button className="btn primary" onClick={openAdd}>+ Add User</button>
      </div>

      <div className="card table-wrap">
        {loading ? <Spinner /> : filtered.length === 0 ? (
          <div className="empty">No users found.</div>
        ) : (
          <table className="tbl compact">
            <thead>
              <tr><th>ID</th><th className="grow">Name</th><th>Mobile</th><th>Email</th><th>Role</th><th>Status</th><th>Device</th><th>Created</th><th></th></tr>
            </thead>
            <tbody>
              {filtered.map(row => (
                <tr key={row.UserId} className="row-link" title="Edit user" onClick={() => openEdit(row)}>
                  <td>#{row.UserId}</td>
                  <td className="grow">
                    <strong>{userName(row)}</strong>
                    {row.FatherHusband && <div className="sub">{row.FatherHusband}</div>}
                  </td>
                  <td>{row.MobileNumber || '-'}</td>
                  <td>{row.EmailId || '-'}</td>
                  <td>{row.SuperAdmin === 1 ? <span className="chip male">Super Admin</span> : <span className="chip pend">User</span>}</td>
                  <td><span className={statusClass(row)}>{statusText(row)}</span></td>
                  <td>{deviceText(row)}{row.DeviceModel && <div className="sub">{row.DeviceModel}</div>}</td>
                  <td>{fmtDateTime(row.CreatedDate)}</td>
                  <td style={{ textAlign: 'right', whiteSpace: 'nowrap' }} onClick={(e) => e.stopPropagation()}>
                    <button className="icon-btn" title="Edit" onClick={() => openEdit(row)}>✎</button>
                    {(row.MobileDeviceId || row.DeviceName) && <button className="btn light sm" title="Unbind phone + browser" onClick={() => resetDevice(row)}>Reset Device</button>}
                    <button className="btn light sm" style={{ marginLeft: 4 }} disabled={isSelf(row)} onClick={() => toggleActive(row)}>{row.IsActive === 0 ? 'Activate' : 'Deactivate'}</button>
                    <button className="icon-btn danger" title="Remove" disabled={isSelf(row)} onClick={() => softDelete(row)}>🗑</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {open && <UserEditForm vm={vm} />}
    </div>
  );
}
